export default {
    BI_READ: 'bi:read',
    BI_DASHBOARD_READ: 'bi.dashboard:read',
    BI_DASHBOARD_WRITE: 'bi.dashboard:write',
    BI_CUSTOM_REPORTS_READ: 'bi.custom.reports:read',
    BI_RULES_READ: 'bi.rules:read',
    BI_QUERY_READ: 'bi.query:read',
    BI_QUERY_WRITE: 'bi.query:write',
};
